import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';

function Calendar({ appointments, onClose }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(null);
  const [hoveredDay, setHoveredDay] = useState(null);
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  const dayNames = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

  const apptsByDay = {};
  appointments.forEach(a => {
    const d = new Date(a.datetime);
    if (d.getFullYear() === year && d.getMonth() === month) {
      const day = d.getDate();
      if (!apptsByDay[day]) apptsByDay[day] = [];
      apptsByDay[day].push(a);
    }
  });

  const today = new Date();

  return (
    <div style={{ background: "var(--bg2)", borderRadius: 16, border: "0.5px solid rgba(83,74,183,0.3)", overflow: "hidden", boxShadow: "0 0 30px rgba(83,74,183,0.08)", marginBottom: 16 }}>
      <div style={{ padding: "14px 20px", borderBottom: "0.5px solid var(--border)", background: "linear-gradient(135deg,rgba(83,74,183,0.08),rgba(29,158,117,0.06))", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#1D9E75", boxShadow: "0 0 8px #1D9E75" }} />
          <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>Calendar</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button onClick={() => setCurrentDate(new Date(year, month - 1, 1))} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text2)", fontSize: 18, padding: "0 4px" }}>‹</button>
          <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", minWidth: 140, textAlign: "center" }}>{monthNames[month]} {year}</span>
          <button onClick={() => setCurrentDate(new Date(year, month + 1, 1))} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text2)", fontSize: 18, padding: "0 4px" }}>›</button>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text3)", fontSize: 20, padding: "0 4px", marginLeft: 8 }}>×</button>
        </div>
      </div>
      <div style={{ padding: "16px 20px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4, marginBottom: 8 }}>
          {dayNames.map(d => (
            <div key={d} style={{ textAlign: "center", fontSize: 11, fontWeight: 600, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.5px", padding: "4px 0" }}>{d}</div>
          ))}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4 }}>
          {Array.from({ length: firstDay }).map((_, i) => <div key={"empty-" + i} />)}
          {Array.from({ length: daysInMonth }).map((_, i) => {
            const day = i + 1;
            const hasAppt = apptsByDay[day];
            const isToday = today.getFullYear() === year && today.getMonth() === month && today.getDate() === day;
            return (
              <div key={day}
                onClick={() => setSelectedDay(selectedDay === day ? null : day)}
                onMouseEnter={() => setHoveredDay(day)}
                onMouseLeave={() => setHoveredDay(null)}
                style={{ aspectRatio: "1", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: 10, background: (selectedDay === day || isToday) ? "linear-gradient(135deg,#534AB7,#1D9E75)" : hoveredDay === day ? "rgba(83,74,183,0.14)" : hasAppt ? "rgba(83,74,183,0.08)" : "transparent", border: (selectedDay === day || isToday) ? "none" : (hoveredDay === day || hasAppt) ? "0.5px solid rgba(83,74,183,0.3)" : "0.5px solid transparent", cursor: "pointer", position: "relative", padding: "6px 2px", transition: "all 0.15s", transform: hoveredDay === day && !(selectedDay === day || isToday) ? "scale(1.08)" : "scale(1)" }}
                title={hasAppt ? hasAppt.map(a => a.lead_name).join(", ") : ""}>
                <span style={{ fontSize: 13, fontWeight: selectedDay === day || isToday || hasAppt ? 700 : 400, color: selectedDay === day || isToday ? "#fff" : hasAppt ? "#534AB7" : "var(--text2)" }}>{day}</span>
                {hasAppt && (
                  <div style={{ display: "flex", gap: 2, marginTop: 2 }}>
                    {hasAppt.slice(0, 3).map((_, idx) => (
                      <div key={idx} style={{ width: 4, height: 4, borderRadius: "50%", background: selectedDay === day || isToday ? "rgba(255,255,255,0.8)" : "#534AB7" }} />
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {selectedDay && (
          <div style={{ marginTop: 16, padding: "14px 16px", borderRadius: 10, background: "rgba(83,74,183,0.06)", border: "0.5px solid rgba(83,74,183,0.2)" }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#534AB7", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.5px" }}>
              {monthNames[month]} {selectedDay}
            </div>
            {apptsByDay[selectedDay] ? apptsByDay[selectedDay].map((a, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: "0.5px solid rgba(83,74,183,0.1)" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }}>{a.lead_name}</div>
                  <div style={{ fontSize: 11, color: "var(--text2)" }}>{new Date(a.datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} · {a.coverage || "—"}</div>
                  {a.notes && <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 2 }}>{a.notes}</div>}
                </div>
                <span style={{ fontSize: 10, fontWeight: 600, padding: "3px 8px", borderRadius: 20, background: a.status === "confirmed" ? "rgba(29,158,117,0.1)" : "rgba(186,117,23,0.1)", color: a.status === "confirmed" ? "#0F6E56" : "#854F0B" }}>{a.status}</span>
              </div>
            )) : (
              <div style={{ fontSize: 12, color: "var(--text3)", textAlign: "center", padding: "12px 0" }}>No appointments on this day</div>
            )}
          </div>
        )}

        {Object.keys(apptsByDay).length > 0 && !selectedDay && (
          <div style={{ marginTop: 16, borderTop: "0.5px solid var(--border)", paddingTop: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 10 }}>This month</div>
            {Object.entries(apptsByDay).sort(([a],[b]) => a-b).map(([day, appts]) => appts.map((a, i) => (
              <div key={a._id || i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: "0.5px solid var(--border)" }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: "linear-gradient(135deg,rgba(83,74,183,0.12),rgba(29,158,117,0.08))", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <span style={{ fontSize: 14, fontWeight: 700, color: "#534AB7", lineHeight: 1 }}>{day}</span>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text)" }}>{a.lead_name}</div>
                  <div style={{ fontSize: 11, color: "var(--text2)" }}>{new Date(a.datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} · {a.coverage || "—"}</div>
                </div>
                <span style={{ fontSize: 10, fontWeight: 600, padding: "3px 8px", borderRadius: 20, background: a.status === "confirmed" ? "rgba(29,158,117,0.1)" : "rgba(186,117,23,0.1)", color: a.status === "confirmed" ? "#0F6E56" : "#854F0B" }}>{a.status}</span>
              </div>
            )))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function Appointments() {
  const { user } = useAuth();
  const [appointments, setAppointments] = useState([]);
  const [leads, setLeads] = useState([]);
  const [form, setForm] = useState({ lead_name: "", lead_id: "", phone: "", datetime: "", coverage: "", notes: "", agent_name: "" });
  const [showAdd, setShowAdd] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);

  const load = () => api.getAppointments().then(setAppointments).catch(() => {});
  useEffect(() => {
    load();
    api.getLeads().then(setLeads).catch(() => {});
    setForm(f => ({ ...f, agent_name: f.agent_name || user?.name || "" }));
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const handleLeadSelect = (e) => {
    const lead = leads.find(l => (l._id || l.id) === e.target.value);
    if (lead) setForm(f => ({ ...f, lead_name: lead.name, lead_id: lead._id || lead.id, phone: lead.phone || '', coverage: lead.coverage || '' }));
  };

  const handleAdd = async () => {
    if (!form.lead_name || !form.datetime) return;
    try { await api.createAppointment(form); await load(); setShowAdd(false); setForm({ lead_name: "", lead_id: "", phone: "", datetime: "", coverage: "", notes: "", agent_name: user?.name || "" }); }
    catch (err) { alert(err.message); }
  };

  const handleCancel = async (id) => {
    if (!window.confirm('Cancel this appointment?')) return;
    try { await api.cancelAppointment(id); await load(); }
    catch (err) { alert(err.message); }
  };

  const handleOutcome = async (id, outcome) => {
    try {
      const appt = appointments.find(a => (a._id || a.id) === id);
      await api.updateAppointment(id, { status: outcome });

      if (outcome === 'sold' && appt) {
        await api.updateStatus(appt.lead_id, { status: 'policy_sold' }).catch(() => {});
        alert('Great! Log this in the Policies tab to send the welcome email.');

      } else if (outcome === 'no_show' && appt) {
        if (appt.ai_enabled) {
          // AI lead — re-enable AI to re-engage automatically
          await api.updateStatus(appt.lead_id, { status: 'contacted' }).catch(() => {});
          await api.toggleLeadAI(appt.lead_id, { ai_enabled: true }).catch(() => {});
        } else {
          // Manual lead — move back to contacted for agent to handle
          await api.updateStatus(appt.lead_id, { status: 'contacted' }).catch(() => {});
        }

      } else if (outcome === 'follow_up' && appt) {
        await api.updateStatus(appt.lead_id, { status: 'follow_up' }).catch(() => {});
      }

      await load();
    } catch (err) { alert(err.message); }
  };

  const upcoming = appointments.filter(a => new Date(a.datetime) >= new Date());
  const past = appointments.filter(a => new Date(a.datetime) < new Date());

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 0, maxWidth: 760 }}>

      {/* Calendar toggle button */}
      <div style={{ marginBottom: 12 }}>
        <button onClick={() => setShowCalendar(s => !s)} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px", borderRadius: 10, border: "0.5px solid rgba(29,158,117,0.3)", background: showCalendar ? "rgba(29,158,117,0.08)" : "var(--bg2)", fontSize: 12, cursor: "pointer", color: showCalendar ? "#0F6E56" : "var(--text2)", fontWeight: 500, transition: "all 0.2s" }}>
          <i className="ti ti-calendar" style={{ fontSize: 15 }} aria-hidden="true" />
          {showCalendar ? "Hide calendar" : "View calendar"}
        </button>
      </div>

      {/* Calendar */}
      {showCalendar && <Calendar appointments={appointments} onClose={() => setShowCalendar(false)} />}

      {/* Appointments list */}
      <div style={{ background: "var(--bg2)", borderRadius: 16, border: "0.5px solid rgba(83,74,183,0.3)", overflow: "hidden", boxShadow: "0 0 30px rgba(83,74,183,0.08)" }}>
        <div style={{ padding: "14px 20px", borderBottom: "0.5px solid var(--border)", background: "linear-gradient(135deg,rgba(83,74,183,0.08),rgba(29,158,117,0.06))", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#534AB7", boxShadow: "0 0 8px #534AB7" }} />
            <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>Appointments <span style={{ color: "var(--text3)", fontWeight: 400 }}>({appointments.length})</span></span>
          </div>
          <button onClick={() => setShowAdd(s => !s)} style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", borderRadius: 8, border: "none", background: "linear-gradient(135deg,#534AB7,#1D9E75)", fontSize: 12, cursor: "pointer", color: "#fff", fontWeight: 600, boxShadow: "0 2px 8px rgba(83,74,183,0.3)" }}>
            + Book appointment
          </button>
        </div>

        {showAdd && (
          <div style={{ padding: "20px", borderBottom: "0.5px solid var(--border)", background: "var(--bg3)", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <div style={{ gridColumn: "1/-1" }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Client name *</div>
              <select onChange={handleLeadSelect} defaultValue="" style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg2)", fontSize: 12, color: "var(--text)", cursor: "pointer" }}>
                <option value="">Select a client...</option>
                {leads.map(l => <option key={l._id || l.id} value={l._id || l.id}>{l.name}</option>)}
              </select>
              {form.lead_name && <div style={{ marginTop: 4, fontSize: 11, color: "#1D9E75" }}>✓ {form.lead_name}</div>}
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Date & time *</div>
              <input type="datetime-local" value={form.datetime} onChange={e => setForm(f => ({ ...f, datetime: e.target.value }))} style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg2)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Coverage type</div>
              <input value={form.coverage} onChange={e => setForm(f => ({ ...f, coverage: e.target.value }))} placeholder="Individual, Group Health..." style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg2)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Agent name</div>
              <input value={form.agent_name} onChange={e => setForm(f => ({ ...f, agent_name: e.target.value }))} placeholder="Your name..." style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg2)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" }}>Notes</div>
              <input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} placeholder="Any notes..." style={{ width: "100%", padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg2)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" }} />
            </div>
            <div style={{ gridColumn: "1/-1", display: "flex", gap: 8 }}>
              <button onClick={handleAdd} style={{ padding: "9px 24px", borderRadius: 8, border: "none", background: "linear-gradient(135deg,#534AB7,#1D9E75)", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Book</button>
              <button onClick={() => setShowAdd(false)} style={{ padding: "9px 16px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "transparent", fontSize: 13, cursor: "pointer", color: "var(--text2)" }}>Cancel</button>
            </div>
          </div>
        )}

        <div>
          {appointments.length === 0 && (
            <div style={{ padding: "60px 20px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
              <div style={{ width: 64, height: 64, borderRadius: 20, background: "linear-gradient(135deg,rgba(83,74,183,0.08),rgba(29,158,117,0.08))", border: "0.5px solid rgba(83,74,183,0.18)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <i className="ti ti-calendar-event" style={{ fontSize: 28, color: "var(--text3)" }} aria-hidden="true" />
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text)", marginBottom: 6 }}>No appointments yet</div>
                <div style={{ fontSize: 13, color: "var(--text3)", maxWidth: 260, lineHeight: 1.5 }}>Book appointments manually or let FLO AI schedule them automatically.</div>
              </div>
              <button onClick={() => setShowAdd(true)} style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 18px", borderRadius: 10, border: "none", background: "linear-gradient(135deg,#534AB7,#1D9E75)", fontSize: 13, cursor: "pointer", color: "#fff", fontWeight: 600, boxShadow: "0 2px 8px rgba(83,74,183,0.3)" }}>
                <i className="ti ti-plus" style={{ fontSize: 14 }} aria-hidden="true" /> Book first appointment
              </button>
            </div>
          )}
          {upcoming.map(a => (
            <div key={a._id || a.id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 20px", borderBottom: "0.5px solid var(--border)", transition: "background 0.1s" }}
              onMouseEnter={e => e.currentTarget.style.background = "var(--bg3)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
              <div style={{ width: 44, height: 44, borderRadius: 12, background: "linear-gradient(135deg,rgba(83,74,183,0.12),rgba(29,158,117,0.08))", border: "0.5px solid rgba(83,74,183,0.2)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <span style={{ fontSize: 10, color: "#534AB7", fontWeight: 700 }}>{new Date(a.datetime).toLocaleDateString('en', { month: 'short' })}</span>
                <span style={{ fontSize: 18, color: "#534AB7", fontWeight: 700, lineHeight: 1 }}>{new Date(a.datetime).getDate()}</span>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", marginBottom: 3 }}>{a.lead_name}</div>
                <div style={{ fontSize: 11, color: "var(--text2)" }}>{new Date(a.datetime).toLocaleString()} · {a.coverage || "—"}</div>
                {a.notes && <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 2 }}>{a.notes}</div>}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 20, background: a.status === "confirmed" ? "rgba(29,158,117,0.1)" : "rgba(186,117,23,0.1)", color: a.status === "confirmed" ? "#0F6E56" : "#854F0B" }}>{a.status}</span>
                <button onClick={() => handleOutcome(a._id || a.id, 'sold')} style={{ padding: "4px 10px", borderRadius: 7, border: "0.5px solid rgba(29,158,117,0.4)", background: "rgba(29,158,117,0.08)", fontSize: 11, cursor: "pointer", color: "#0F6E56", fontWeight: 500 }}>Sold</button>
                <button onClick={() => handleOutcome(a._id || a.id, 'follow_up')} style={{ padding: "4px 10px", borderRadius: 7, border: "0.5px solid rgba(83,74,183,0.4)", background: "rgba(83,74,183,0.08)", fontSize: 11, cursor: "pointer", color: "#534AB7", fontWeight: 500 }}>Follow up</button>
                <button onClick={() => handleOutcome(a._id || a.id, 'no_show')} style={{ padding: "4px 10px", borderRadius: 7, border: "0.5px solid rgba(186,117,23,0.4)", background: "rgba(186,117,23,0.08)", fontSize: 11, cursor: "pointer", color: "#854F0B", fontWeight: 500 }}>No show</button>
                <button onClick={() => handleCancel(a._id || a.id)} style={{ padding: "4px 10px", borderRadius: 7, border: "0.5px solid rgba(240,149,149,0.5)", background: "transparent", fontSize: 11, cursor: "pointer", color: "#A32D2D" }}>Cancel</button>
              </div>
            </div>
          ))}
          {past.length > 0 && (
            <div style={{ padding: "10px 20px", background: "var(--bg3)", borderTop: "0.5px solid var(--border)" }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>Past</div>
              {past.map(a => (
                <div key={a._id || a.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: "0.5px solid var(--border)" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text)" }}>{a.lead_name}</div>
                    <div style={{ fontSize: 11, color: "var(--text2)" }}>{new Date(a.datetime).toLocaleString()} · {a.coverage || "—"}</div>
                  </div>
                  <span style={{ fontSize: 10, fontWeight: 600, padding: "3px 8px", borderRadius: 20,
                    background: a.status === 'sold' ? "rgba(29,158,117,0.1)" : a.status === 'no_show' ? "rgba(240,149,149,0.1)" : a.status === 'follow_up' ? "rgba(83,74,183,0.1)" : "rgba(0,0,0,0.05)",
                    color: a.status === 'sold' ? "#0F6E56" : a.status === 'no_show' ? "#A32D2D" : a.status === 'follow_up' ? "#534AB7" : "var(--text3)" }}>
                    {a.status === 'sold' ? '✓ Sold' : a.status === 'no_show' ? 'No show' : a.status === 'follow_up' ? 'Follow up' : 'Past'}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}